/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ProductSearchServices.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali - H175591
 *
 * @Date                : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
******************************************************************************/
import { CategoryListing, SearhcResultSet } from "../PurchaseSoftware";
import ProdutSearchCacheServices from './ProductSearchCacheService';
import { logInfo } from "../../../utils/console-utility";

class ProductSearchServices {

    static setResponseFor(searchTerm, response: SearhcResultSet) {
        return ProdutSearchCacheServices.addToCache(searchTerm, response);
    }

    static get(searchTerm): SearhcResultSet | undefined {
        return ProdutSearchCacheServices.get(searchTerm);
    }

    static getMatchedProducts(products: CategoryListing[], searchTerm: string): SearhcResultSet {
        const cacheRespons = ProductSearchServices.get(searchTerm.toLowerCase());
        if (cacheRespons) {
            return cacheRespons;
        } else {
            const matchedResponse = ProductSearchServices.searchProductWith(products, searchTerm);
            // Cache them.
            ProductSearchServices.setResponseFor(searchTerm, matchedResponse);
            return matchedResponse;
        }
    }

    // Maps products with hidden true/false.
    private static searchProductWith(products: CategoryListing[], searchTerm: string): SearhcResultSet {
        searchTerm = searchTerm.toLocaleUpperCase();
        let matchedAny: boolean = false;
        return {
            results: products.map(category => {
                if (category.products) {
                    return {
                        ...category, products: category.products.map(product => {
                            logInfo('product.productName ', product.productName);
                            const matchedValue = (product.productName && (product.productName.toLocaleUpperCase().indexOf(searchTerm) > -1)) ||
                                (product.platforms && (product.platforms.toLocaleUpperCase().indexOf(searchTerm) > -1));
                            if (!matchedAny && matchedValue) {
                                matchedAny = true;
                            }
                            if (matchedValue) {
                                return { ...product, hidden: false }
                            }
                            return { ...product, hidden: true };
                        })
                    }
                }
                return { ...category }
            }),
            matchedAny,
        }
    }

    static reset() {
        ProdutSearchCacheServices.reset();
    }
}



export default ProductSearchServices;